import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import NoSSR from '../../../context/ssr/no-ssr';
import { GliderWrapper, IMenuGliderItems, MenuGliderItems } from '../../organisms';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import { IIcon } from '../../atoms/icons/icon';
import IconArrowLeft from '../../atoms/icons/icon-arrow-left';
import IconArrowRight from '../../atoms/icons/icon-arrow-right';

export interface IMenuGlider {
  items?: IMenuGliderItems['items'];
  activeSlideIndex?: number;
  onItemSelectedCallback?: (id: number) => void;
}

const ssrPlaceholder = (props: IMenuGliderItems, cn: IClassNames) => {
  return (
    <div className={cn.gliderWrapper}>
      <MenuGliderItems {...props} isSSR />
    </div>
  );
};

const iconLeft = (): React.ReactElement<IIcon> => <IconArrowLeft size="xxxsmall" color="blue" />;
const iconRight = (): React.ReactElement<IIcon> => <IconArrowRight size="xxxsmall" color="blue" />;

const classNames = (): IClassNames =>
  makeClassNames({
    gliderWrapper: 'menu-glider--wrapper',
  });

const MenuGlider: React.FC<IMenuGlider> = ({ items, activeSlideIndex, onItemSelectedCallback }) => {
  const cn = useMemo(() => classNames(), []);
  const gliderComponentProps: IMenuGliderItems = {
    items,
    activeSlideIndex,
    variant: 'mgv',
    onItemSelectedCallback,
  };

  return (
    <NoSSR placeholder={ssrPlaceholder(gliderComponentProps, cn)}>
      <GliderWrapper
        Component={MenuGliderItems}
        bordered="top-bottom"
        duration={2}
        exactWidth
        hasArrows
        iconLeft={iconLeft()}
        iconRight={iconRight()}
        itemWidth={66}
        propsComponent={gliderComponentProps}
        scrollLock
        topOffset
      />
    </NoSSR>
  );
};
/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  MenuGlider.propTypes = {
    activeSlideIndex: PropTypes.number,
    items: PropTypes.array,
    onItemSelectedCallback: PropTypes.func,
  };
}
export default MenuGlider;
